<template>
  <div class="acceptance order-info" id="orderlist">
    <div class="title-order">
      申请退款
      <span>温馨提示：一个订单只允许成功退款一次</span>
    </div>
    <!-- <div class="goods-info">
      <div class="title-mode title-accept">订单信息</div>
      <div class="order-num">
        订单编号：
        <span>{{ orderList.orderNo }}</span>
      </div>
      <div class="goods">
        <div class="goods-tab">
          <div class="shang">商品</div>
          <div class="shuliang">数量</div>
          <div class="baozhuang">包装方式</div>
        </div>

        <div class="goods-list">
          <div
            class="item-goods"
            v-for="(item, index) in orderList.orderItems"
            :key="index"
            v-if="index < indexNum"
          >
            <img :src="item.imgUrl" alt />
            <div class="goods-name">{{ item.name }}</div>
            <div class="goods-num">{{ item.count }}</div>
            <div class="bangzhuang">{{ item.packingMethod }}</div>
          </div>
        </div>
        <div
          class="accept-more"
          v-if="orderList.orderItems.length > 3 && indexNum == 3"
          @click="indexNum = 99"
        >
          查看更多
          <svg class="icon iconbiaodan_rili_left" aria-hidden="true">
            <use xlink:href="#iconbiaodan_rili_left" />
          </svg>
        </div>
      </div>
    </div> -->
    <order-row ref="orderRow" :info="orderList"></order-row>

    <div class="goods-info">
      <div class="title-mode title-accept">师傅信息</div>
      <div class="worker_info">
        <div class="worker_tips">退款前请先与师傅沟通订单服务情况</div>
        <div style="display: flex">
          <div class="worker_lable">
            <span>师傅信息：</span>
            <template
              v-if="
                orderList.orderPickupCar && orderList.orderPickupCar.driverName
              "
            >
              {{ orderList.orderPickupCar.dispatcher }}
              <i class="t_phone">{{
                orderList.orderPickupCar.dispatcherPhone || "/"
              }}</i>
            </template>
            <template v-else>
              {{
                orderList.orderExpand && orderList.orderExpand.pickupWorkerName
                  ? orderList.orderExpand.pickupWorkerName
                  : orderList.workerName
              }}
              <i class="t_phone">{{
                orderList.orderExpand && orderList.orderExpand.pickupWorkerPhone
                  ? orderList.orderExpand.pickupWorkerPhone
                  : orderList.workerPhone
              }}</i>
            </template>
          </div>
          <div class="worker_lable" style="color: #f75658">
            <span>订单状态：</span
            >{{
              orderList.orderExpand &&
              orderList.orderExpand.pickupWorkerPhone &&
              orderList.childOrder.status
                ? setStatus(orderList.childOrder.status, orderList)
                : orderList.statusName
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="applyinfo">
      <div class="title-mode title-accept">申请信息</div>
      <div class="apply-content">
        <div class="biaoti"><span>*</span>退款</div>
        <el-select
          class="select-el"
          v-model="content"
          placeholder="请选择退款原因"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <div class="order-price">
          <span>订单总金额</span>
          {{ orderList.totalAmount }}
        </div>

        <div class="text-modify">· 师傅补贴费用</div>
        <el-input
          v-model="subsidy"
          oninput="value=value.replace(/[^0-9.]/g,'')"
          @input="rechargeMoney"
          :placeholder="'最多￥' + placeholder + '元'"
        ></el-input>
        <div class="text-modify">
          · 退款金额
          <div class="right-text">
            <div class="pirce-modify">
              {{ (orderList.totalAmount - subsidy).toFixed(2) }}
            </div>
            <div class="price-content">
              *师傅补贴费为支付给师傅的费用，退款金额=订单总金额-师傅补贴费
            </div>
          </div>
        </div>

        <div class="order-price biaoti"><span>*</span>详细描述</div>

        <el-input
          v-model="description"
          placeholder="请输入问题描述"
          type="textarea"
          :maxlength="500"
        ></el-input>

        <div class="order-price">上传凭证</div>
        <div class="upload-modify">
          <a-upload
            :action="baseApl + '/common/common/upload_file'"
            listType="picture-card"
            :fileList="fileList"
            @preview="handlePreview"
            @change="handleChange"
          >
            <div v-if="fileList.length < 8">
              <a-icon type="plus" />
              <div class="ant-upload-text">图片</div>
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
        <!-- <div class="refund-userinfo">
          <div class="tab-input">
            <div class="input-title biaoti"><span>*</span>联系人</div>
            <el-input v-model="contactName" placeholder="请输入"></el-input>
          </div>
          <div class="tab-input">
            <div class="input-title biaoti"><span>*</span>联系电话</div>
            <el-input
              v-model="contactPhone"
              placeholder="请输入"
              type="text"
              maxlength="11"
            ></el-input>
          </div>
        </div> -->
        <el-button class="submit" @click="onRefund()" :loading="onLoading"
          >提交申请</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import orderRow from "@/components/order/orderRow";
import { ORDER_STATUS } from "@/utils/constant";
import { arithmeticMultiply, arithmeticDivide } from "@/utils/util";

export default {
  components: {
    orderRow,
  },
  data() {
    return {
      options: [],
      content: "",
      description: "",
      contactName: "",
      contactPhone: "",
      imgs: [],
      previewVisible: false,
      previewImage: "",
      fileList: [],
      indexNum: 3,
      placeholder: "",
      subsidy: "",
      onLoading: false,
      orderList: {
        orderItems: [],
      },
      baseApl: process.env.VUE_APP_BASE_API,
    };
  },
  activated() {
    var _this = this;
    _this.content = "";
    _this.contactName = "";
    _this.contactPhone = "";
    _this.subsidy = "";
    _this.description = "";
    _this.fileList = [];
    this.content = "";
    for (let i of _this.$store.state.userList) {
      i.isSelected = false;
      if (i.name == "退款订单") {
        i.isSelected = true;
      }
    }
    this.$fetch(`order/api/order/${_this.$route.query.orderid}`).then((res) => {
      if (res.code == 0) {
        _this.orderList = res.data;
        _this.orderList.childOrder = res.data.childOrder || {};
        console.log(res.data);
        // 回显消息
        if (res.data.refundDetailResponse) {
          _this.content = res.data.refundDetailResponse.refundReason;
          _this.contactName = res.data.refundDetailResponse.contactName;
          _this.contactPhone = res.data.refundDetailResponse.contactPhone;
          _this.subsidy = res.data.refundDetailResponse.allowance;
          _this.description = res.data.refundDetailResponse.description;
          res.data.refundDetailResponse.imgs.map((i, index) => {
            _this.fileList.push({
              uid: index,
              name: "name",
              status: "done",
              url: i.url,
              response: { data: { url: i.url } },
            });
          });
        }

        if (res.data.childOrder.status && res.data.orderExpand.pickupWorkerPhone)
          _this.placeholder = res.data.childOrder.workerCashIntransit;
        else _this.placeholder = res.data.workerCashIntransit;
      } else {
        this.$message(res.message);
      }
    });
    this.$fetch(`order/api/refund/reason`).then((res) => {
      if (res.code == 0) {
        _this.options = res.data;
      } else {
        this.$message(res.message);
      }
    });
  },
  mounted() {
    // var _this = this;
    // for (let i of _this.$store.state.userList) {
    //   i.isSelected = false;
    //   if (i.name == "退款订单") {
    //     i.isSelected = true;
    //   }
    // }
    // this.$fetch(`order/api/order/${_this.$route.query.orderid}`).then(
    //     res => {
    //       if (res.code == 0) {
    //         _this.orderList=res.data;
    //         _this.placeholder=res.data.workerCashIntransit;
    //       } else {
    //         this.$message(res.message);
    //       }
    //     });
  },

  methods: {
    setStatus(status, item) {
      console.log(status);
      // if(status=='WAIT_PICK_UP') return item.statusName
      for (let i in ORDER_STATUS) {
        if (i == status) return "送货-" + ORDER_STATUS[i].name;
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange({ fileList }) {
      this.fileList = fileList;
      // if (
      //   fileList[0].type === "image/jpeg" ||
      //   fileList[0].type === "image/png"
      // ) {
      //   this.fileList = fileList;
      // } else {
      //   return;
      // }
    },
    // 输入的金额
    rechargeMoney(e) {
      if (e > Number(this.placeholder))
        return (this.subsidy = this.placeholder);

      if (e.split(".").length == 3) {
        this.subsidy = e.substr(0, e.length - 1);
      } else {
        if (e.split(".")[1]) {
          // this.markupPrice = Math.floor(e * 10000) / 10000;
          this.subsidy = arithmeticDivide(
            Math.floor(arithmeticMultiply(e, 100)),
            100
          );
        }
      }
    },
    // 判断上传是否为图片
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      if (!isJPG) {
        this.$message.error("图片只能上传jpg、png格式");
      }
      //   const isLt2M = file.size / 1024 / 1024 < 2
      //   if (!isLt2M) {
      //     this.$message.error('Image must smaller than 2MB!')
      //   }

      return isJPG;
    },
    // 申请退款
    onRefund() {
      let _this = this;
      let imgs = [];
      if (_this.content == "") {
        this.$message.error("请选择退款原因");
        return;
      }
      if (!_this.subsidy && _this.subsidy!==0) {
        this.$message.error("请填写师傅补贴费用");
        return;
      }
      this.onLoading = true;
      for (let i of this.fileList) {
        imgs.push(i.response.data.url);
      }
      if (this.$route.query.type == "renew" || this.$route.query.type == null) {
        this.$post(`order/api/order/${this.$route.query.orderid}/cancel`, {
          allowance: _this.subsidy,
          content: _this.content,
          contactName: _this.contactName,
          contactPhone: _this.contactPhone,
          description: _this.description,
          imgs: imgs,
          verifyWorkerId:
            this.orderList.childOrder && this.orderList.childOrder.workerId
              ? this.orderList.childOrder.workerId
              : this.orderList.workerId,
        })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success("提交成功");
              this.fileList = [];
              this.$router.push({ path: "/user/order/refund" });
            } else {
              this.$message(res.message);
            }
          })
          .finally(() => (this.onLoading = false));
      } else if (this.$route.query.type == "modify") {
        this.$post(`order/api/refund/${this.$route.query.orderid}/modify`, {
          allowance: _this.subsidy,
          content: _this.content,
          contactName: _this.contactName,
          contactPhone: _this.contactPhone,
          description: _this.description,
          imgs: imgs,
          verifyWorkerId:
            this.orderList.childOrder && this.orderList.childOrder.workerId
              ? this.orderList.childOrder.workerId
              : this.orderList.workerId,
        })
          .then((res) => {
            if (res.code == 0) {
              this.$message.success("提交成功");
              this.fileList = [];
              this.$router.push({ path: "/user/order/refund" });
            } else {
              this.$message(res.message);
            }
          })
          .finally(() => (this.onLoading = false));
      }
      console.log(imgs);
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.ant-upload-list-picture-card-container {
  width: 83px;
  height: 83px;
}
.worker_info {
  padding: 20px;
  background: #fff;
  .worker_tips {
    color: #ffad16;
    line-height: 12px;
    margin-bottom: 12px;
  }
  .worker_lable {
    color: #2f3133;
    font-size: 12px;
    line-height: 12px;
    span {
      color: #5e6066 !important;
    }
    i {
      font-style: normal;
    }
  }
  .worker_lable + .worker_lable {
    margin-left: 67px;
  }
}
</style>
<style lang="scss">
.goods-info {
  // margin-top: 10px;
  .goods {
    background: #fff;
    .goods-tab {
      background: #f9fafa;
      height: 30px;
      font-size: 12px;
      color: #5e6066;
      display: flex;
      div {
        line-height: 31px;
        text-align: center;
      }
      .shang {
        width: 370px;
      }
      .shuliang {
        width: 300px;
      }
      .baozhuang {
        width: 187px;
      }
    }
    .goods-list {
      // margin-top: 10px;
      padding: 10px 20px;
      .item-goods {
        display: flex;
        font-size: 12px;
        color: #2f3133;
        margin-bottom: 10px;
        div {
          display: flex;
          align-items: center;
        }
        img {
          width: 50px;
          height: 50px;
          margin-right: 12px;
        }
        .goods-name {
          width: 310px;
          height: 50px;
        }
        .goods-num {
          width: 300px;
          justify-content: center;
        }
        .bangzhuang {
          width: 187px;
          justify-content: center;
        }
      }
      .item-goods:hover {
        background: #f9fafa;
        cursor: pointer;
      }
    }
    .goods-basic-info {
      padding: 0 20px;
      display: flex;
      font-size: 12px;
      .tabclass {
        margin-right: 60px;
        color: #2f3133;
        .label {
          color: #5e6066;
          margin-right: 10px;
        }
      }
    }

    .markup {
      padding: 0 20px;
      margin-top: 20px;
      font-size: 12px;
      color: #5e6066;
      .markup-item {
        color: #2f3133;
        margin-bottom: 5px;
        span {
          margin-right: 45px;
        }
      }
      .markup-item:nth-child(1) {
        margin-top: 3px;
      }
      .markup-item:last-child {
        margin-bottom: 0;
      }
    }
    .step_one_price {
      margin-top: 10px;
      padding: 0 20px 37px 20px;
      font-size: 12px;
      color: #2f3133;
      margin-bottom: 0;
      .one_tab {
        align-items: flex-end;
      }
      .one_total {
        font-size: 26px;
        height: 26px;
      }
    }
  }
}
.applyinfo {
  .el-input__inner {
    width: 271px;
    font-size: 14px;
    border: 1px solid #dcdfe6 !important;
    padding-left: 15px;
    border-radius: 0;
  }
  .el-textarea__inner {
    border-radius: 2px;
    width: 547px;
    height: 130px;
    margin-top: 10px;
    border-radius: 2px;
    resize: none;
  }
  .el-input__inner:hover,
  .el-input__inner:focus,
  .el-textarea__inner:hover,
  .el-textarea__inner:focus {
    border-color: #3455d3 !important;
  }
  .el-input .el-input__suffix {
    width: 30px;
  }

  .refund-userinfo {
    margin-top: 32px;
    display: flex;
    justify-content: flex-start;
    .input-title {
      height: 14px;
      font-size: 14px;
      color: rgba(47, 49, 51, 1);
      line-height: 1;
      margin-bottom: 10px;
    }
    .tab-input {
      margin-right: 12px;
    }
  }
}
.upload-modify {
  margin-top: 10px;
  height: 83px;
  .ant-upload-list {
    width: auto !important;
  }
  .ant-upload-list-picture-card .ant-upload-list-item,
  .ant-upload.ant-upload-select-picture-card {
    width: 83px;
    height: 83px;
    border-radius: 2px;
  }
  .ant-upload.ant-upload-select-picture-card:hover {
    border-color: #3455d3;
  }

  .ant-upload-list-picture .ant-upload-list-item,
  .ant-upload-list-picture-card .ant-upload-list-item {
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
.title-order {
  display: flex;
  align-items: center;

  span {
    color: #909399;
    font-size: 12px;
    margin-left: 15px;
  }
}
.order-num {
  height: 44px;
  background: #ffffff;
  font-size: 12px;
  color: #5e6066;
  display: flex;
  align-items: center;
  padding: 15px 20px;
  span {
    color: #2f3133;
    margin-left: 20px;
  }
}
#orderlist {
  .title-accept {
    margin-bottom: 0;
  }
  .applyinfo {
    margin-top: 15px;
    .apply-content {
      background: #ffffff;
      padding: 15px 20px 24px 20px;
      .biaoti {
        font-size: 14px;
        height: 14px;
        line-height: 1;
        margin-bottom: 10px;
        span {
          color: #f75658;
          margin-right: 0;
        }
      }
    }
    .order-price {
      font-size: 14px;
      height: 14px;
      line-height: 1;
      color: #2f3133;
      margin-top: 32px;
      span {
        margin-right: 10px;
      }
    }
    .text-modify {
      font-size: 12px;
      height: 12px;
      line-height: 1;
      color: #2f3133;
      margin-top: 24px;
      margin-bottom: 12px;
      display: flex;
      .right-text {
        margin-left: 24px;
        .pirce-modify {
          color: #f75658;
          margin-bottom: 8px;
        }
        .price-content {
          color: #909399;
        }
      }
    }
    .submit {
      width: 167px;
      height: 30px;
      background: rgba(52, 85, 211, 1);
      border-radius: 2px;
      font-size: 14px;
      color: #ffffff;
      margin-top: 32px;
      border-color: rgba(52, 85, 211, 1);
      border-radius: 2px;
    }
    .submit:hover {
      background: #2c4abb;
    }
  }
}
</style>
